export const TEXT_SIZES = {
  sm: "text-xs sm:text-sm",
  base: "text-sm sm:text-base",
  md: "text-base sm:text-lg",
  lg: "text-lg sm:text-xl",
  xl: "text-xl sm:text-2xl",
} as Record<string, string>;

export const TEXT_COLORS = {
  default: "",
  black: "text-dark",
  white: "text-white",
  red: "text-red-600",
  gray: "text-accent",
  green: "text-primary",
} as Record<string, string>;
